export const env_production = false; // process.env.NODE_ENV === 'production';
console.log('env_production', env_production);
export const devUrls = {
  coreUrl: !env_production && 'http://192.168.0.29',
  reduxDevToolsIP: !env_production && '192.168.0.29',
};

export const dias = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
export const gMapKey = env_production ? 'AIzaSyDN_oz_WKAMqmU8AfRlsT3lgEhSlUQLVCc' : 'AIzaSyBvqCrOsMaIqxohVE10QDrwsT_xou3H6BI';
export const cantAcompanantes = 6;
export const minCronGet = 300000; // 5 min
export const version_system = 'v2.4.2';
export const coreUrl = env_production ? 'https://jaits.app' : devUrls.coreUrl;
export const empresaUrl = window.location.origin;
export const array_colors = [
  '#880e4f',
  '#4a148c',
  '#1B4C93',
  '#361E52',
  '#048664',
  '#311b92',
  '#F461E1',
  '#1a237e',
  '#0d47a1',
  '#E51B00',
  '#01579b',
  '#1AA3AD',
  '#8F0527',
  '#006064',
  '#004d40',
  '#1b5e20',
  '#33691e',
  '#827717',
  '#4C2879',
  '#f57f17',
  '#ff6f00',
  '#e65100',
  '#bf360c',
  '#3e2723',
  '#263238',
  '#5E5A96',
  '#45365D',
  '#F45337',
];



// WEBPACK FOOTER //
// src/core/constants.js